import React, { useContext } from "react";
import { Link } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import { CartContext } from "../context/CartContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProductCard = ({ product }) => {
  const { cart, addToCart } = useContext(CartContext);

  const handleAddToCart = (productId, quantity) => {
    const cartItem = cart.find((item) => item.product.id === productId);
    const currentQuantity = cartItem ? cartItem.quantity : 0;
    const newQuantity = currentQuantity + quantity;

    // Check if minimumOrderQty or stockQty conditions are violated
    if (
      newQuantity > product.minimumOrderQty ||
      newQuantity > product.stockQty
    ) {
      const maxQty = Math.min(product.minimumOrderQty, product.stockQty);

      // Dismiss any previous toasts to prevent duplicates
      toast.dismiss();
      toast.error(
        `You cannot add more than ${maxQty} of "${product.title}" to the cart.`,
        { autoClose: 3000 }
      );
      return;
    }

    // Proceed to add product to cart
    try {
      addToCart(productId, quantity);

      // Dismiss any previous toasts to prevent duplicates
      toast.dismiss();
      // toast.success(`Added "${product.title}" to the cart.`, { autoClose: 2000 });
    } catch (error) {
      console.error("Error adding product to cart:", error);
      toast.dismiss();
      toast.error(`Failed to add "${product.title}" to the cart.`, {
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      {product && (
        <div className="card bordercolor">
          <Link to={`/product/` + product?.id}>
            <div className="product-card-img p-3">
              <img
                src={`${product.image.length > 0
                  ? process.env.REACT_APP_API_URL +
                  process.env.REACT_APP_product_IMAGE_URL +
                  product.image[0]
                  : "https://upload.wikimedia.org/wikipedia/commons/9/92/No_Preview_1.jpg"
                  }`}
                className="card-img-top"
                alt={product?.image}
              />
            </div>
          </Link>
          <div className="card-body text-center">
            <Link to={`/product/` + product?.id} className="nav-link">
              <h6 className="card-title mb-3 fw-bold">
                {product?.title?.split(" ").length > 8
                  ? product?.title?.split(" ").slice(0, 8).join(" ") + "..."
                  : product?.title}
              </h6>
              <div className="d-flex justify-content-center align-items-center mb-2 text-center">
                <p
                  className="card-text me-1"
                  style={{
                    textDecoration: "line-through",
                    color: "#888",
                    marginBottom: 0,
                  }}
                >
                  ₹{product?.price}
                </p>
                <p
                  className="card-text me-3"
                  style={{
                    color: "green",
                    fontWeight: "500",
                    marginBottom: 0,
                    fontSize: "15px",
                  }}
                >
                  {product?.discount_percentage}% off
                </p>
                <p
                  className="card-text"
                  style={{
                    fontWeight: "bold",
                    color: "#e75a5a",
                    marginBottom: 0,
                  }}
                >
                  ₹{product?.update_price}
                </p>
              </div>
              <div className="mb-3">
                <p
                  className="card-text"
                  style={{
                    fontWeight: "300",
                    color: "#616161",
                    fontSize: "12px",
                  }}
                >
                  SKU-{product?.sku}
                </p>
              </div>
            </Link>
            {product.stockQty > 0 ? (
              <button
                onClick={() =>
                  handleAddToCart(product.id, product?.minimumOrderQty)
                }
                className="btn btncustom rounded-5 w-75"
              >
                Add to cart
                <Icon.Cart3 className="ms-2" />
              </button>
            ) : (
              <h6 className="outofstockbtn">Out of stock</h6>
            )}
          </div>
          <ToastContainer theme="dark" autoClose={2000} />
        </div>
      )}
    </>
  );
};

export default ProductCard;
